import React from 'react';
import { Archive, Sparkle, HouseLine } from '@phosphor-icons/react';
import type { ArchiveSession } from '../../lib/utils';
interface ArchiveSessionCardProps {
  session: ArchiveSession;
  offerCount: number;
  succesCounterpartyName?: string;
  onOpen?: () => void;
}
export function ArchiveSessionCard({
  session,
  offerCount,
  succesCounterpartyName,
  onOpen
}: ArchiveSessionCardProps) {
  const closedAt = new Date(session.closedAt).toLocaleDateString('ro-RO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return <button type="button" onClick={onOpen} className="w-full text-left rounded-2xl bg-dark-2 border border-dark-4 hover:border-light-4 transition-colors overflow-hidden cursor-pointer" data-id="element-202">
      <div className="px-5 py-4 flex items-center gap-4" data-id="element-203">
        <div className="w-12 h-12 rounded-2xl bg-dark-3 border border-dark-4 inline-flex items-center justify-center shrink-0" data-id="element-204">
          <Archive size={20} weight="duotone" className="text-light-2" data-id="element-205" />
        </div>
        <div className="min-w-0 flex-1" data-id="element-206">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-207">
            <p className="text-base font-semibold text-light-1 truncate" data-id="element-208">
              {session.name}
            </p>
            {session.succesOfferId && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-lime-5 border border-lime-4 text-[10px] font-medium text-lime-1" data-id="element-209">
                <Sparkle size={10} weight="fill" data-id="element-210" />
                Închiriat
              </span>}
          </div>
          <p className="text-xs text-light-3 mt-0.5" data-id="element-211">
            Închisă pe {closedAt} · {offerCount}{' '}
            {offerCount === 1 ? 'ofertă' : 'oferte'}
          </p>
          {succesCounterpartyName && <p className="text-xs text-light-4 mt-1 inline-flex items-center gap-1.5" data-id="element-212">
              <HouseLine size={12} data-id="element-213" />
              Cu {succesCounterpartyName}
            </p>}
        </div>
      </div>
    </button>;
}